import { LOGIN, LOGOUT } from './types';

export const setLogin = (value: boolean) => ({
    type: LOGIN,
    payload: value
})

export const setLogout = () => ({ type: LOGOUT })